import React from 'react'
import styled from 'styled-components'
import ComponentRenderer from '../ComponentRenderer'

const StyledCTA = styled.div`
  align-items: center;
  border-radius: 8px;
  box-shadow: 0 1px 1px 0 rgba(10, 22, 70, 0.1),
  0 0 1px 0 rgba(10, 22, 70, 0.06), 0 28px 70px -7px rgba(5, 15, 54, 0.16);
  display: flex;
  flex-direction: column;
  margin-bottom: 48px;
  margin-top:4 8px;
  padding: 32px;
`

const PostBlogEmbeddableCTA = ({ cmsData }) => (
  <StyledCTA>
    {cmsData.items['en-US'].map((item, index) => (
      <ComponentRenderer
        key={'cr-' + index}
        tag={item.sys.contentType.sys.id}
        cmsData={item.fields}
      />
    ))}
  </StyledCTA>
)


export default PostBlogEmbeddableCTA
